import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReactionPicture, useReactionPicture } from '../../components/panels/ReactionPicture';
import { publicReactionPath } from './publicAccess';

interface PublicReactionCardProps {
  readonly reactionId: string;
  /** Its title, or its scheme ("A + B → C"); null when neither is known (a search result untitled). */
  readonly label: string | null;
  /** Omitted for search results, which don't carry it; null when none has been recorded. */
  readonly authorName?: string | null | undefined;
}

/** #1136: one public reaction in the public home's grid -- drawn as its paper draws it, linking to /r/<id>. */
export function PublicReactionCard({ reactionId, label, authorName }: PublicReactionCardProps) {
  const { t } = useTranslation();
  const drawn = useReactionPicture(reactionId);
  return (
    <li className="public-drawing-card public-reaction-card" data-testid="public-reaction-card">
      <Link to={publicReactionPath(reactionId)}>
        <span className="public-drawing-card-thumb">
          <ReactionPicture state={drawn} />
        </span>
        <span className="public-drawing-card-title">{label || t('reactionResults.untitled')}</span>
        {authorName !== undefined ? (
          <span className="public-drawing-card-author">
            {t('publicPages.byAuthor', { author: authorName || t('publicPages.unknownAuthor') })}
          </span>
        ) : null}
      </Link>
    </li>
  );
}
